module.exports = __webpack_public_path__ + "static/drake-yes-2c60e12e502445cb9b2b3281459e2ae1.png";